'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdAirlineSeatLegroomNormal = function MdAirlineSeatLegroomNormal(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm34.1 30q1.1 0 1.8 0.7t0.7 1.8-0.7 1.8-1.8 0.7h-7.5v-11.6h-11.6q-2 0-3.5-1.5t-1.5-3.5v-13.4h10v10h8.4q1.3 0 2.3 1t0.9 2.4v11.6h2.5z m-25.7-10q0 2 1.4 3.5t3.6 1.5h10v3.4h-10q-3.5 0-5.9-2.5t-2.5-5.9v-15h3.4v15z' })
        )
    );
};

exports.default = MdAirlineSeatLegroomNormal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/airline-seat-legroom-normal.js
// module id = 1173
// module chunks = 168707334958949